import { useState } from "react";

const DEFAULT_FALLBACK = "/assets/logo-fallback.svg";

export default function LogoImage({
  src,
  alt = "",
  className = "",
  style,
  fallbackSrc = DEFAULT_FALLBACK,
  hideOnError = false,
  ...rest
}) {
  const [err, setErr] = useState(false);
  if (!src) return null;
  if (err && hideOnError) return null;
  return (
    <img
      src={err ? fallbackSrc : src}
      alt={alt}
      className={className}
      style={style}
      onError={() => setErr(true)}
      {...rest}
    />
  );
}
